import { createContext, useContext } from 'react';
export const AccordionContext = createContext(undefined);
export const useAccordionContext = () => {
    const context = useContext(AccordionContext);
    if (context === undefined) {
        throw new Error('useAccordionContext must be used within a AccordionProvider');
    }
    return context;
};
//# sourceMappingURL=AccordionContext.js.map